// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Section_paragraph__2XMWs","heading":"Section_heading__ptB2s","container":"Section_container__11Q6i"};